export default{
  formatterDate: function (date) {
    let result = new Date(date);
    return result;
  },
  get_unix_time: function (dateStr) {
    var newstr = dateStr.replace(/-/g,'/');
    var date =   new Date(newstr);
    var time_str = date.getTime().toString();
    return time_str.substr(0, 13);
  }
}

export function setItem (key, value) {
  sessionStorage.setItem(key, value);
}

export function getItem (key) {
  return sessionStorage.getItem(key);
}



// WEBPACK FOOTER //
// ./src/store/untils.js